<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
  <l-dashboard-highlight-card [metric]="highlight" />

  @for (metric of metrics; track metric.title + metric.period) {
    <l-dashboard-metric-card [metric]="metric" />
  }
</div>
